import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import { Loader } from '../loader';
import 'react-rangeslider/lib/index.css';
import "react-phone-number-input/style.css";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import { getRecentAvailableMedicalRecords } from "../../actions/contracts";
import {updateMedicalRecordMultipleRecordIds} from "../../actions/medicalRecords";
import { changeDateFormat} from "../../utils/helper";
import moment, { now } from "moment";
import DatePicker from "react-datepicker";
import filterFactory, {
  textFilter,
  selectFilter
} from "react-bootstrap-table2-filter";
import _  from 'lodash';


const $ = window.$;
const { SearchBar } = Search;
const initialState={
  currentFormNotValid: false,
  petId: 'Specific',
  customPetId: '',
  message: '',
  loadingInfo: false,
  customerCount: null,
  searchedMedicalRecords:[],
  arrival_date_picker: '',
};
let formdata = {};
let selected_medical_records = [];

const selectRow = {
  mode: "checkbox",
  onSelect: (row, isSelect, rowIndex, e) => {    
    let arrayIndex = null;
    if(isSelect){   
    selected_medical_records.push(row);
    }
    else{
    arrayIndex =  _.findIndex(selected_medical_records, function(item) { return item.id == row.id; });
      if(arrayIndex >= 0){
        selected_medical_records.splice(arrayIndex,1);
      }   
    }
  },

  onSelectAll: (isSelect, rows, e) => {  
    let arrayIndex = null;
      if(isSelect){    
      selected_medical_records = [ ...rows, ...selected_medical_records ];
      }
      else{
        rows.forEach(item2 =>{   
            arrayIndex =  _.findIndex(selected_medical_records, function(item) { return item.id == item2.id; });
            if(arrayIndex >= 0){
              selected_medical_records.splice(arrayIndex,1);
            }         
        });      
      }
  },
};

class ArrivalDateChange extends React.Component {
  constructor(props) {
    super(props);
  }

  state = initialState;

  tableHecaderColumnData = [
    {
      dataField: "pet_id",
      text: "Pet ID",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span className="m-topbar__userpic">
            <img
              src={
                process.env.REACT_APP_S3_PATH +
                "/" +
                row.avatar_path +
                "/" +
                row.avatar_file_name
              }
              className="m--img-rounded m-width-50 mr-2"
              alt=""
            />
            <span className="m-badge m-badge--info mx-auto my-0 px-2">
              <strong>{cell}</strong>
            </span>
          </span>
        );
      }
    },
    {
      dataField: "breed_type",
      text: "Breed",
      sort: true
    },
    {
      dataField: "sex",
      text: "Gender",
      sort: true,
      formatter: cell => cell
    },
    {
      dataField: "arrival_date",
      text: "Arrival Date",
      formatter: (cell, row) => {  
        let date = changeDateFormat(cell, "MM-DD-YYYY", "MM-DD-YYYY");
        return <span>{date}</span> 
      },
      sort: true,    

    },     
  ];
 

  componentDidMount = () => {
    this.props.getRecentAvailableMedicalRecords({ petIdInput:null });
  };

  changeDate = value => {
    this.setState({ 
      arrival_date: moment(value, "MM-DD-YYYY"), 
      arrival_date_picker: moment(value, "MM-DD-YYYY").toDate() 
    });
  };

  componentWillReceiveProps = (nextProps) => {

    if(this.props.searchedMedicalRecords !== nextProps.searchedMedicalRecords){    
      let availablePuppies = nextProps.searchedMedicalRecords && nextProps.searchedMedicalRecords.length > 0 ? nextProps.searchedMedicalRecords : [];
      for(let puppy of availablePuppies ){
        puppy.arrival_date = puppy.arrival_date ? moment(puppy.arrival_date).format('MM-DD-YYYY'):'';          
      }
      this.setState({ searchedMedicalRecords : availablePuppies, loadingInfo : false });
    } 

    if(nextProps.updatedMultipleRecords && this.props.updatedMultipleRecords !== nextProps.updatedMultipleRecords){      
      this.setState({ loadingInfo : false, arrival_date_picker : '' });
      selected_medical_records = [];
      NotificationManager.success("Arrival date updated successfully.");
      $("#change-arrival-date-modal").modal("hide");
      this.props.getRecentAvailableMedicalRecords({ petIdInput:null });
      this.props.updatedArrivalDate();
    }

    if(this.props.updatedMultipleRecordsError !== nextProps.updatedMultipleRecordsError){ 
      this.setState({ loadingInfo : false,});
      NotificationManager.error("An error occurred while updating the arrival date.");
      $("#change-arrival-date-modal").modal("hide");  
    }
  }

  submitChangeArrivalDate = () => {  
    if(selected_medical_records && selected_medical_records.length > 0){
      if(this.state.arrival_date){
      let arrivalDate = changeDateFormat(this.state.arrival_date, "MM-DD-YYYY", "YYYY-MM-DD");
      let selectedMedicalRecordIds = [];
      for(let record of selected_medical_records){
        if(record && record.id){
          selectedMedicalRecordIds.push(record.id);
        }
      };
      let data = {
        ArrivalDate : arrivalDate,
        medicalRecordIds : selectedMedicalRecordIds,
      };
      this.setState({ loadingInfo : true }); 
      this.props.updateMedicalRecordMultipleRecordIds(data);
      }else{
        NotificationManager.error("Please select new arrival date.");
      }

    }else{
      NotificationManager.error("Please select at least one puppy.");
    }

  }

  render() {
    const {searchedMedicalRecords,arrival_date_picker} = this.state;

    return (
      <div className="modal fade show" id="change-arrival-date-modal" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">            
            <form className="m-form">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">Change Arrival Date</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">          
                  <div className="row">
                    <div className="col-xl-12">
                      <label className='pr-2'>New Arrival Date :</label>
                       <DatePicker                
                          selected={arrival_date_picker}
                          value={arrival_date_picker}
                          onChange={this.changeDate}
                          onSelect={this.changeDate}    

                         />
                    </div>
                  </div>       
                  <div className="row">
                        <div className="col-xl-12">
                          {!this.state.loadingInfo?
                            <ToolkitProvider 
                            keyField="id"
                            data={searchedMedicalRecords}                      
                            columns={this.tableHecaderColumnData}
               
                            defaultSortDirection="asc" 
                            hover={true} 
                            filter={ filterFactory() } 
                          >
                            {
                              props => (
                                <div>
                                  <div className='px-0 mb-4 search-bar'>
                                    <div className='col-lg-3 px-0 inner-addon right-addon'>
                                    {/* <i className="fas fa-search"></i> */}
                                    {/* <SearchBar {...props.searchProps} /> */}
                                    </div>
                                  </div>
                                  <BootstrapTable
                                    classes="petTable"
                                    {...props.baseProps}
                                    pagination={ paginationFactory() }                                 
                                    selectRow={selectRow}                                                          
                                  />
                                </div>
                              )
                            }
                            </ToolkitProvider>:  
                            <div className="center-row">
                             </div>

                           }
                        </div>
                  </div>             
                </div>
                <div className="modal-footer"> 
                  {!this.state.loadingInfo ? 
                    <div>
                       <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Close</button>
                       <button type="button" className="btn btn-primary m-btn--pill" onClick={() => this.submitChangeArrivalDate()}>Update</button>
                     </div>
                     :
                     <div className="center-row">
                       <Loader size={50} />
                    </div>
                 }
                 </div>
              </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
    data: state,
    searchedMedicalRecords: state.contractsReducer.searchedMedicalRecords,
    searchedMedicalRecordsError: state.contractsReducer.searchedMedicalRecordsError,
    updatedMultipleRecords : state.medicalRecordsReducer.updatedMultipleRecords,
});

const mapDispatchToProps = dispatch => ({
  getRecentAvailableMedicalRecords: (data)=>{
    dispatch(getRecentAvailableMedicalRecords(data));
  },
  updateMedicalRecordMultipleRecordIds: (data)=> {
    dispatch(updateMedicalRecordMultipleRecordIds(data));
  }
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ArrivalDateChange));
